import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Utils } from "../../utils/utils";
import { PersonaService } from "../../servicios/persona.service";
import { Observable } from "rxjs";
import { VehiculoService } from "../../servicios/vehiculo.service";
import { startWith, map } from "rxjs/operators";
import { Subject } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface Vehiculo {
  id: string;
  valor: string;
}

@Component({
  selector: "app-asignacion-transportador-vehiculo",
  templateUrl: "./asignacion-transportador-vehiculo.component.html",
  styleUrls: ["./asignacion-transportador-vehiculo.component.css"],
})
export class AsignacionTransportadorVehiculoComponent implements OnInit {
  loading = false;
  dataPersona = [];
  dataPersonaVehiculo = [];
  tipoPersonaVehiculo = [];
  tienePersonaVehiculo = 0;
  isSelectedPersona = false;
  vehiculos: Vehiculo[];
  filteredVehiculos: Observable<Vehiculo[]>;
  dataAsignacion = {
    idPersona: "",
    idVehiculo: "",
    idTipoPersonaVehiculo: "",
    idUsuario: "",
  };

  personaVehiculoGroup: FormGroup;
  personaGroup: FormGroup;
  vehiculoGroup: FormGroup;

  personaSeleccionada: any;

  constructor(
    private formBuilder: FormBuilder,
    private servicePersona: PersonaService,
    private serviceVehiculo: VehiculoService,
    private snackBar: MatSnackBar,
    public ruta: Utils
  ) {
    this.personaGroup = this.formBuilder.group({
      formPersona: [""],
    });

    this.vehiculoGroup = this.formBuilder.group({
      formVehiculo: [""],
      formTipoPersonaVehiculo: [""],
    });

    this.serviceVehiculo.getVehiculos(0).subscribe((result) => {
      this.vehiculos = result;

      this.filteredVehiculos = this.vehiculoGroup
        .get("formVehiculo")
        .valueChanges.pipe(
          startWith(""),
          map((usuario) =>
            usuario ? this._filterVehiculos(usuario) : this.vehiculos.slice()
          )
        );
    });

    this.servicePersona.getTipoPersonaXVehiculo(0).subscribe((result) => {
      this.tipoPersonaVehiculo = result;
    });
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  displayFn = (vehiculo) => {
    // now you have access to 'this'
    //console.log(vehiculo);
    if (vehiculo != "" && vehiculo != null) {
      this.dataAsignacion.idVehiculo = vehiculo.id;
      return vehiculo ? vehiculo.valor : vehiculo;
    } else {
      return;
    }
  };

  /*displayFn(vehiculo) {
    //console.log(JSON.stringify(vehiculo));
    this.procesoPersonaVehiculo();
    
    return vehiculo ? vehiculo.valor : vehiculo;
  }*/

  private _filterVehiculos(value: any): Vehiculo[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.vehiculos.filter(
      (vehiculo) => vehiculo.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  busqueda(event: any) {
    const busqueda = event.target.value;

    this.loading = true;
    this.servicePersona
      .getBusquedaPersonaTipoPerfil(busqueda, 2)
      .subscribe((data) => {
        this.isSelectedPersona = false;
        this.dataPersona = data;
        this.loading = false;
      });
  }

  detallePersona(persona) {
    this.personaSeleccionada = persona;
    console.log(this.personaSeleccionada);
    this.loading = true;
    this.dataAsignacion.idPersona = persona.IdPersona;
    this.servicePersona
      .getPersonaXVehiculo(persona.IdPersona)
      .subscribe((result) => {
        this.dataPersonaVehiculo = result;
        if (this.dataPersonaVehiculo.length > 0) {
          this.tienePersonaVehiculo = 1;
        } else {
          this.tienePersonaVehiculo = 2;
        }
        this.loading = false;
      });
    this.isSelectedPersona = true;
    console.log(persona);
  }

  selectChange(event) {
    this.dataAsignacion.idTipoPersonaVehiculo = event;
    //this.dataAsignacion.idTipoPersonaVehiculo=this.vehiculoGroup.controls["formTipoPersonaVehiculo"].value;
    console.log(event);
  }

  procesoPersonaVehiculo() {
    //console.log(this.dataAsignacion);
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.dataAsignacion.idUsuario = infoUsuario[0].IdUsuario;
    this.servicePersona
      .postPersonaVehiculo(this.dataAsignacion)
      .subscribe((result) => {
        this.isSelectedPersona = false;
        this.tienePersonaVehiculo = 0;
        this.dataPersona = [];
        this.personaGroup.reset();
        this.vehiculoGroup.reset();
        this.dataAsignacion = {
          idPersona: "",
          idVehiculo: "",
          idTipoPersonaVehiculo: "",
          idUsuario: "",
        };
        this.snackBar.open("Vehiculo Asignado", "Asignar Vehiculo", {
          duration: 2000,
        });
      });
  }
}
